import { takeLatest, put, call, all } from "redux-saga/effects";
import { AttendanceActionTypes } from "./attendance.types";
import { encryptData } from "../../_common/enode-decode";

import {
  fetchAttendanceSuccess,
  fetchAttendanceFailure,
  fetchAttendanceChanged,
  updateAttendanceSuccess,
  updateAttendanceFailure,
  updateAttendanceChanged,
  fetchAttendanceDownloadDetailsSuccess,
  fetchAttendanceDownloadDetailsFailure,
  fetchAttendanceDownloadDetailsChanged,
  attendanceExportAllFailure,
  attendanceExportAllSuccess,
  attendanceExportAllChanged,
} from "./attendance.action";
import {
  getAttendance,
  updateAttendanceCall,
  downloadAttendanceCall,
  ComonExportPage,
} from "./attendance.service";

export function* fetchAttendanceAsync({
  payload,
}: any): Generator<any, void, any> {
  try {
    const jsonData = {
      Date: payload.Date,
      UserID: payload.UserID,
      CompanyID: payload.CompanyID,
      InstanceName: payload.InstanceName,
      UserType: payload.discribtion,
      InputSearch: payload.searchValueSet,
      BranchID: payload.BranchID,
      Limit: payload.Limit,
    };
    const AttendanceData = encryptData(jsonData, "GetUserAttendanceKey");
    const response = yield call(getAttendance, AttendanceData);
    yield put(fetchAttendanceSuccess(response.data));
  } catch (error) {
    yield put(fetchAttendanceFailure(error));
  }
}

export function* watchAttendance() {
  yield takeLatest(
    AttendanceActionTypes.FETCH_ATTENDANCE_START,
    fetchAttendanceAsync,
  );
}

export function* fetchAttendanceReset() {
  yield put(fetchAttendanceChanged());
}

export function* watchAttendanceReset() {
  yield takeLatest(
    AttendanceActionTypes.ATTENDANCE_RESET,
    fetchAttendanceReset,
  );
}

function* updateAttendance({ payload }: any): any {
  try {
    const attendanceListArr = JSON.stringify(payload.AttendanceList).replace(
      /"/g,
      "'",
    );
    const {
      Date,
      UserID,
      CompanyID,
      UpdatedBy,
      discribtion,
      searchValueSet,
      InstanceName,
      BranchID,
    } = payload;
    const jsonData = {
      DateOFAttendance: Date,
      UserID: UserID,
      AttendanceList: attendanceListArr,
      CompanyID: CompanyID,
      UpdatedBy: UpdatedBy,
      UserType: discribtion,
      InputSearch: searchValueSet,
      InstanceName: InstanceName,
      BranchID: BranchID,
    };
    const AttendanceData = encryptData(jsonData, "UpdateAttendanceKey");
    const response = yield call(updateAttendanceCall, AttendanceData);
    if (response.status === 200) {
      yield put(updateAttendanceSuccess(response.data));
    } else {
      yield put(updateAttendanceFailure(response.data.message));
    }
  } catch (error: any) {
    yield put(updateAttendanceFailure(error.message));
  }
}

export function* onUpdateAttendanceStart() {
  yield takeLatest(
    AttendanceActionTypes.UPDATE_ATTENDANCE_START,
    updateAttendance,
  );
}

export function* updateAttendanceReset() {
  yield put(updateAttendanceChanged());
}

export function* onUpdateAttendanceReset() {
  yield takeLatest(
    AttendanceActionTypes.UPDATE_ATTENDANCE_RESET,
    updateAttendanceReset,
  );
}

// Download Attendance

function* downloadAttendance({ payload }: any): any {
  try {
    const jsonData = {
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      UserID: payload.UserID,
      CompanyID: payload.CompanyID,
      BranchID: payload.BranchID,
      InstanceName: payload.InstanceName,
      UserType: payload.discribtion,
      InputSearch: payload.searchValueSet,
      Limit: payload.Limit,
    };
    const AttendanceData = encryptData(jsonData, "GetAttendanceKey");
    const response = yield call(downloadAttendanceCall, AttendanceData);
    if (response.status === 200) {
      yield put(fetchAttendanceDownloadDetailsSuccess(response.data));
    } else {
      yield put(fetchAttendanceDownloadDetailsFailure(response.data.message));
    }
  } catch (error) {
    yield put(fetchAttendanceDownloadDetailsFailure(error));
  }
}

export function* onDownloadAttendanceStart() {
  yield takeLatest(
    AttendanceActionTypes.FETCH_ATTENDANCE_DOWNLOAD_DETAILS_START,
    downloadAttendance,
  );
}

export function* updateAttendanceDownloadReset() {
  yield put(fetchAttendanceDownloadDetailsChanged());
}

export function* onDownloadAttendanceReset() {
  yield takeLatest(
    AttendanceActionTypes.FETCH_ATTENDANCE_DOWNLOAD_DETAIL_RESET,
    updateAttendanceDownloadReset,
  );
}

/** *********************** SATRT CALL BACK EXPORT  LIST ************************ */
export function* attendanceListExport({ payload }: any) {
  const key: any = "CreateRequestReportKey";
  try {
    const jsonData: any = {
      BranchID: payload.BranchID,
      IsFresh: payload.IsFresh,
      ConditionExec: payload.ConditionExec,
      ExistRequestID: payload.ExistRequestID,
      CreateDateTime: payload.CreateDateTime,
      RequestReportPage: payload.RequestReportPage,
      CompanyID: payload.CompanyID,
      RequestedBy: payload.RequestedBy,
      URL: payload.URL,
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      MemberID: payload.MemberID,
      DateType: payload.DateType,
      InstanceName: payload.InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(ComonExportPage, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(attendanceExportAllFailure(responseData.data));
    } else {
      yield put(attendanceExportAllSuccess(responseData.data));
    }
  } catch (error) {
    yield put(attendanceExportAllFailure(error));
  }
}
export function* attendanceExportAllReset() {
  yield put(attendanceExportAllChanged());
}
export function* onExportListAttendance() {
  yield takeLatest(
    AttendanceActionTypes.ATTENDANCE_EXPORT_START,
    attendanceListExport,
  );
}
export function* onAttendanceExportReset() {
  yield takeLatest(
    AttendanceActionTypes.ATTENDANCE_EXPORT_RESET_START,
    attendanceExportAllReset,
  );
}
/************************* END CALL BACK EXPORT ALL  LIST ************************ */

export function* attendanceSaga() {
  yield all([
    call(watchAttendance),
    call(watchAttendanceReset),
    call(onUpdateAttendanceStart),
    call(onUpdateAttendanceReset),
    call(onDownloadAttendanceStart),
    call(onDownloadAttendanceReset),
    call(onExportListAttendance),
    call(onAttendanceExportReset),
  ]);
}
